import { Spinner } from '../../ui/Spinner/Spinner';
import { Container } from '../../ui/Container/Container';
import useUserEnableLogin from './useUserEnableLogin';
import { AlertMessage } from '../../ui/AlertMessage/AlertMessage';
import { AlertStatus } from '../../ui/AlertMessage/AlertStatus';
import { Helpers } from '../../../utils/helpers';
import { Col, Row } from 'react-bootstrap';

export const UserEnableLogin = () => {
  const manager = useUserEnableLogin();

  const handleVerifyKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      void manager.verifyMember();
    }
  };

  return (
    <Container className="page-container">
      <h3>Add New User</h3>
      <Row>
        <Col lg={10} md={8} sm={12}>
          <p className="text-muted">
            Search for an existing member by member ID to enable them as a user who can sign into
            the membership application.
          </p>

          <AlertMessage
            status={AlertStatus.ERROR}
            message={manager.alertMessage}
            visible={!Helpers.isNullOrWhiteSpace(manager.alertMessage)}
          />

          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="mb-3">
                <label htmlFor="memberId">Member ID</label>
                <div className="input-group">
                  <input
                    type="text"
                    id="memberId"
                    maxLength={255}
                    className={`form-control ${
                      manager.fieldErrors.includes('memberId') ? 'is-invalid' : ''
                    }`}
                    value={manager.memberId}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                      manager.updateMemberId(e.currentTarget.value);
                    }}
                    onKeyPress={handleVerifyKeyPress}
                    placeholder="Enter member ID"
                  />
                  <button
                    className="btn btn-outline-primary"
                    onClick={manager.verifyMember}
                    disabled={manager.isVerifying || Helpers.isNullOrWhiteSpace(manager.memberId)}>
                    {manager.isVerifying ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Verifying...
                      </>
                    ) : (
                      'Verify Member'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {manager.verifiedUser && (
            <div className="mb-3">
              <label>Member Information</label>
              <div className="border rounded p-3">
                <h5 className="mb-3">Member Verified</h5>
                <div className="row">
                  <div className="col-md-6">
                    <strong>Name:</strong> {manager.verifiedUser.firstName}{' '}
                    {manager.verifiedUser.lastName}
                  </div>
                  <div className="col-md-6">
                    <strong>Email:</strong> {manager.verifiedUser.emailAddress}
                  </div>
                </div>
                {manager.verifiedUser.cellPhone && (
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <strong>Cell Phone:</strong> {manager.verifiedUser.cellPhone}
                    </div>
                  </div>
                )}
                <div className="mt-3">
                  <p className="text-muted mb-2">
                    This member will be enabled as a user who can sign into the membership
                    application.
                    <br />
                    After enabling the user, you&apos;ll be taken to the user editor to set their
                    permissions.
                  </p>
                  <button
                    className="btn btn-success"
                    onClick={manager.enableLogin}
                    disabled={manager.isEnabling}>
                    {manager.isEnabling ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Enabling User...
                      </>
                    ) : (
                      'Add User'
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};
